import { useState } from 'react'
import { downloadGooglePass } from '../../../utilities/api'
import { showGoogleWalletButton } from '../../../utilities/walletDevice'

import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

import addToGoogleWalletSVG from '../../../assets/icons/add-to-google-wallet.svg'

export default function GooglePassButton({ event, obj, alwaysShow = false }) {
  const [errorModal, setErrorModal] = useState({ show: false, message: '' })
  const showError = (message) => setErrorModal({ show: true, message })
  const hideError = () => setErrorModal((s) => ({ ...s, show: false }))

  const downloadGoogleWalletPass = async () => {
    const payload = {
      event: event,
      ticket: obj,
    }
    try {
      const response = await downloadGooglePass(payload)
      if (response.status === 200) {
        const link =
          typeof response.data === 'string'
            ? response.data
            : (response.data?.url ?? response.data?.data?.url)
        if (link) {
          window.open(link, '_blank', 'noopener,noreferrer')
        } else {
          console.error(
            'Add to Google Wallet: empty link in response',
            response.data
          )
          showError(
            "We couldn't get a Google Wallet link. Please try again or contact support."
          )
        }
      } else {
        console.log('Google response: ', response, response.status)
        console.error(
          'Failed to download the pass.',
          response.status,
          response.data
        )
        showError(
          `Could not open Google Wallet (HTTP ${response.status}). Please try again.`
        )
      }
    } catch (err) {
      const status = err.response?.status
      const body = err.response?.data
      console.error('Failed to download the pass.', status, body ?? err.message)
      showError('Could not add this pass to Google Wallet. Please try again.')
    }
  }

  if (!alwaysShow && !showGoogleWalletButton()) return null

  return (
    <>
      <Button
        onClick={downloadGoogleWalletPass}
        variant="info"
        aria-label="Add to Google Wallet"
        className="wallet-pass-btn wallet-pass-btn--google mt-0"
      >
        <img src={addToGoogleWalletSVG} alt="add to google wallet" />
      </Button>
      <Modal
        show={errorModal.show}
        onHide={hideError}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Google Wallet</Modal.Title>
        </Modal.Header>
        <Modal.Body>{errorModal.message}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={hideError}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
